import React from 'react'
import styles from './Main.module.css'

export default function Main() {
    
    return (
        <div className='background-main'>
            <h1 className='title title-name'>Andy Lee</h1>
            <h3 className='title title-description'>Web Developer</h3>
            <div className='triangle-one'></div>
            <div className='triangle-two'></div>
            <div className='triangle-three'></div>
            <div className='circle-one'></div>
            <div className='square-one'></div>
            <div className='circle-two'></div>
        </div>
    )
}
